<button class="btn capitalize btn-{{type}} font-sm {{size}} {{custom}} {{(text ==='not available')?'not-available':''}}"
[disabled]="isDisabled" [ngClass]="(isDisabled)?'disable':''"
[ngStyle]="{'width': _commonService.deviceType() == 'mobile' ? mwidth : dwidth,
'height': _commonService.deviceType() == 'mobile' ? mheight : dheight,
'font-size': _commonService.deviceType() == 'mobile' ? mfntSize : dfntSize}" >
    <img *ngIf="isImageLeft && imageSrc" class="img left" [src]="imageSrc" [alt]="'cancel'" width="100%">
    <!-- <span> -->
        {{text === 'not available' ? 'Claim' : text}}
    <!-- </span> -->
    <img *ngIf="isImageRight && imageSrc" class="img right" [src]="imageSrc" [alt]="'cancel'" width="100%">
</button>
